import PropTypes from 'prop-types';
import { BsStars } from 'react-icons/bs';

import { EXAMPLE_PROMPTS } from '../../constants/conversation';

/**
 * The first screen of a conversation: the question, the composer, three example briefs.
 */
const EmptyState = ({ composer, onPrompt }) => (
	<div className="flex min-h-0 flex-1 flex-col overflow-y-auto px-6 py-8">
		<div className="m-auto flex w-full flex-col items-center">
			<div className="mb-4 grid h-10 w-10 place-items-center rounded-card bg-primary-500 text-white">
				<BsStars className="h-5 w-5" />
			</div>
			<h2 className="mb-1.5 text-[26px] font-semibold tracking-tight text-text">Wen suchen Sie?</h2>
			<p className="mb-7 max-w-md text-center text-sm text-bgBase-800">
				Branche oder Beschreibung, Region, besondere Kriterien – ich suche, prüfe und finde auf Wunsch direkt
				die Ansprechpartner.
			</p>
			{composer}
			<div className="mt-5 grid w-full max-w-[720px] grid-cols-1 gap-2.5 sm:grid-cols-3">
				{EXAMPLE_PROMPTS.map((prompt) => (
					<button
						key={prompt.title}
						type="button"
						onClick={() => onPrompt(prompt.text)}
						className="rounded-card border border-bgBase-500 bg-white p-3 text-left transition-colors hover:border-bgBase-600 hover:bg-bgBase-300"
					>
						<div className="text-sm leading-snug text-text">{prompt.title}</div>
						<div className="mt-1 text-xs leading-snug text-bgBase-800">{prompt.subtitle}</div>
					</button>
				))}
			</div>
		</div>
	</div>
);

EmptyState.propTypes = {
	composer: PropTypes.node.isRequired,
	onPrompt: PropTypes.func.isRequired,
};

export default EmptyState;
